export const API = {
    SUBSCRIPTIONPLAN: "/plans/all-plans/",
    CREATE_ORDER: "/plans/payment/",
    COMPLETE_PAYMENT: "/plans/transaction/",
    SEND_OTP: "/account/sendotp/",
    REGISTER_USER: "/account/api/landing/register/",
    BOOK_DEMO: "/account/api/landing/demo-booking/"
}